
<div *ngIf="isLoading">
  <app-loading-spinner></app-loading-spinner>
</div>

<!-- Default form register -->
<div class="col-md-12">


<form *ngIf="!isLoading" #form="ngForm"  [formGroup]="validatingForm" class="text-center border border-light p-5">

    <p class="h4 mb-4">Add Book !!</p>


   <!-- book title -->

    <input type="text" id="title" mdbInput mdbValidate  #title formControlName="title" class="form-control mb-4" placeholder="Enter book title " aria-describedby="title" name="title">
   <!-- Book  Description -->
    <input type="text" id="Description" #description formControlName="description" mdbInput mdbValidate class="form-control mb-4" placeholder="Enter book Description " aria-describedby="Description">


   <!-- Phone number -->
    <input type="text" id="Image" formControlName="image" mdbInput mdbValidate class="form-control mb-4" placeholder="Enter book Image " aria-describedby="Image">


   <!-- Phone number -->
    <input  type="number"mdbInput mdbValidate  formControlName="rate" id="rate" class="form-control mb-4" placeholder="Enter book rate " aria-describedby="rate">

<!-- 
    <small id="title" class="form-text text-muted mb-4">
      please enter book title 
</small> -->
    <!-- Sign up button -->
    <button mdbBtn color="danger" [disabled] = "!form.valid" block="true" class="my-4" type="submit" (click)="on(form)">Add book</button>

  </form>
  <!-- Default form register -->

</div>
